<template>
	<div>
		<label>{{pre_item.name}}:</label>
		<el-date-picker v-model="pre_item.val" type="year" :class="[pre_item.class==''?'short0':pre_item.class]"
			value-format="yyyy-MM-dd" placeholder="选择日期" @change="val_back">
		</el-date-picker>
		<em v-show="pre_item.w=='1'">*</em><em v-show="pre_item.w=='0'"></em>
	</div>
</template>

<script>
	//
	export default {
		name: "hj-dateyear",
		data() {
			return {
				pre_item: {},
			}
		},
		props: {
			inData: {
				type: String,
				default: ''
			}
		},
		watch: {
			inData(val) {
				// console.log('跟踪', this.pre_item);
				this.pre_item = {};
				// this.pre_item = JSON.parse(this.inData);
				let t = {};
				t = JSON.parse(this.inData);
				// this.inData 对应val 是字符串,不是日期变量
				const tdate = new Date(t.val);
				// if (str.length > 4) {
				// 	t.val = str.substring(0, 4);
				// }
				t.val = tdate;
				// console.log('校验后', t);
				this.pre_item = t;
				// this.init();
			}
		},
		created() {
			// console.log('创建', this.pre_item);
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);

			// this.init();
		},
		activated: function() {
			// console.log('hj-dateyear 组件激活时调用 激活');
			// console.log('激活', this.inData);
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);
			// this.init();
		},
		deactivated: function() {
			// console.log('hj-dateyear 组件激活时调用 停用');
			this.pre_item = {};
		},
		methods: {
			init: function() {
				// console.log('初始化', this.inData);
				if (typeof(this.inData) === 'undefined') {
					return;
				}
				this.pre_item = {};
				let t = {};
				t = JSON.parse(this.inData);

				let str = '';
				str = t.val;
				if (str.length > 4) {
					t.val = str.substring(0, 3);
				}
				// console.log('校验后', t);
				this.pre_item = JSON.parse(t);
			},
			val_back: function() {
				this.$emit('com-event', this.pre_item);
			}
		}
	}
</script>

<style>
</style>